import { render, staticRenderFns } from "./ModelManagerContextMenuBase.vue?vue&type=template&id=9530a2ac&"
import script from "./ModelManagerContextMenuBase.vue?vue&type=script&lang=js&"
export * from "./ModelManagerContextMenuBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports